import { inject, Injectable } from '@angular/core';
import { isAnalyticsCookiesAllowed } from '../../services/cookie-consent.storage';
import { GtmService } from '../../shared/services/gtm.service';
import { isGaAllowlistedEventName } from './ga-analytics.allowlist';

@Injectable({
  providedIn: 'root',
})
export class GaAnalyticsService {
  private readonly gtm = inject(GtmService);

  trackEventName(name: string): void {
    if (!isGaAllowlistedEventName(name)) {
      return;
    }

    if (!isAnalyticsCookiesAllowed()) {
      return;
    }

    this.gtm.push({ event: name });
  }
}
